import {
    GET_CATALOG,
    GET_CATALOG_RESULT,
    CATALOG_LOADINGS,
    CLEAR_REDUX
} from 'config/redux/actionTypes';

export const getCatalog = (keys, force = false, params) => ({
    type: GET_CATALOG,
    payload: { keys, force, params }
});

export const getCatalogResult = (data) => ({
    type: GET_CATALOG_RESULT,
    payload: data
});

export const catalogLoadigns = (loadings) => ({
    type: CATALOG_LOADINGS,
    payload: loadings,
});

export const clearRedux = (option, parameters) => ({
    type: CLEAR_REDUX,
    payload: { option: option || "", parameters }
});
